import { getBlockerStyle, spinnerKeyframe } from './shared-styles-from-theme-fluent';

export const getLocalBlockerStyle = palette => (Object.assign({
  '.blocker-local': {
    alignItems: 'center',
    backgroundColor: 'rgba(51,51,51,0.15)',
    display: 'flex !important',
    justifyContent: 'center',
    position: 'absolute',
    zIndex: 20,

    '& > .blocker-indicator': {
      alignItems: 'center',
      backgroundColor: 'white',
      color: palette.themePrimary,
      display: 'flex',
      outline: 'none',
      padding: 10,

      '& > .blocker-image': getBlockerStyle(28, palette),
    },
  },
}, spinnerKeyframe));
